import React from 'react';

export default function PerformanceEvaluationLayout({ children }) {
  return (
    <div className="perf-layout">
      <div className="wrapper">{children}</div>
    </div>
  );
}
